export class MainScene extends Phaser.Scene {
    map: Phaser.Tilemaps.Tilemap;
    cursors;
    debugGraphics;
    text: Phaser.GameObjects.Text;
    player: Phaser.Physics.Arcade.Sprite;
    showDebug = false;
    groundLayer: Phaser.Tilemaps.DynamicTilemapLayer;
    coinLayer: Phaser.Tilemaps.DynamicTilemapLayer;
    coinsCollected = 0;
    doubleJump: boolean = true;
    frameCount: number = 0;
    spriteTiles: Phaser.Tilemaps.Tile[] = [];

    constructor() {
        super({
            key: "MainScene"
        });
    }

    preload(): void {
        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image('ground_1x1', require("/src/assets/qci/tilemaps/tiles/ground_1x1.png"));
        this.load.tilemapTiledJSON('map', require("/src/assets/qci/tilemaps/maps/tile-collision-testv2.json"));
        this.load.spritesheet('coin', require("/src/assets/phaser-assets/sprites/coin.png"), { frameWidth: 32, frameHeight: 32 });
        this.load.image('player', require("/src/assets/phaser-assets/sprites/phaser-dude.png"));
        this.load.image("jump-button", require("/src/assets/games/coinRunner/player.png"));

    }

    create(): void {
        this.map = this.make.tilemap({ key: 'map' });
        var groundTiles = this.map.addTilesetImage('ground_1x1');
        var coinTiles = this.map.addTilesetImage('coin');

        this.map.createDynamicLayer('Background Layer', groundTiles, 0, 0);
        this.groundLayer = this.map.createDynamicLayer('Ground Layer', groundTiles, 0, 0);
        this.coinLayer = this.map.createDynamicLayer('Coin Layer', coinTiles, 0, 0);

        // Tiles with IDs 1-25 will cause collision
        this.groundLayer.setCollisionBetween(1, 25);
        // Allow collision from the bottom only on tile 17. Platforms anyone?
        this.groundLayer.layer.data.forEach((row: Phaser.Tilemaps.Tile[]) => {
            row.forEach(tile => {
                if (tile.index === 17) {
                    tile.setCollision(false, false, true, false);
                }
            });
        });

        // The IDs are generated from the tilemap
        // This will set Tile ID 26-30 (the coin tile) to call the function "hitCoin" when collided with
        this.coinLayer.setTileIndexCallback([26, 27, 28, 29, 30], this.hitCoin, this);
        this.coinLayer.layer.data.forEach((row: Phaser.Tilemaps.Tile[]) => {
            row.forEach(tile => {
                if (tile.index === 26) {
                    this.spriteTiles.push(tile);
                }
            });
        });

        // This will set the map location (2, 0) to call the function "hitSecretDoor" Un-comment this to
        // be jump through the ceiling above where the player spawns. You can use this to create a
        // secret area.
        this.groundLayer.setTileLocationCallback(2, 0, 1, 1, this.hitSecretDoor, this);

        this.player = this.physics.add.sprite(80, 70, 'player');
        this.player.setBounceY(0.1);

        // We want the player to physically collide with the ground, but the coin layer should only
        // trigger an overlap so that collection a coin doesn't kill player movement.
        this.physics.add.collider(this.player, this.groundLayer);
        this.physics.add.overlap(this.player, this.coinLayer);

        // Setup the camera
        this.cameras.main.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);
        this.cameras.main.startFollow(this.player);

        this.debugGraphics = this.add.graphics();

        this.input.keyboard.on('keydown_C', (event) => {
            this.showDebug = !this.showDebug;
            this.drawDebug();
        });

        this.input.keyboard.on('keydown_SPACE', () => {
            this.attemptJump();
        });
        this.input.keyboard.on('keydown_UP', () => {
            this.attemptJump();
        });

        this.cursors = this.input.keyboard.createCursorKeys();

        // STUFF
        // Lets do a button on click thingy
        var jumpButton = this.add.sprite(10, (this.textures.game.config.height as number) - 70, "jump-button");
        jumpButton.setOrigin(0);
        jumpButton.setInteractive();
        jumpButton.setDisplaySize(64, 64);
        jumpButton.setScrollFactor(0); // Stops this item from scrolling with the background via the camera
        jumpButton.setAlpha(.33);
        jumpButton.on("pointerdown", () => {
            this.attemptJump();
            this.player.emit("funtimes", this.player.x, this.player.y);
        });

        this.player.setDragX(10);
        this.player.setBounceX(0);
        // END STUFF

        // ADD NPC
        var blockConst: number = this.map.tileWidth;
        var npc = this.add.sprite(1 * blockConst, 9 * blockConst, "jump-button");
        npc.setOrigin(0);
        npc.setInteractive();
        npc.setDisplaySize(blockConst, blockConst);
        var npcText = this.add.text(npc.x, npc.y - 32, "DANG, YOU FOUND ME!");
        npcText.visible = false;

        // Check if player is nearby when this is fired
        this.player.on('funtimes', (x: number, y: number) => {
            console.warn("X", Math.abs(npc.x - x) / 32); // JB - Remove this console.warn
            console.warn("Y", Math.abs(npc.y - y) / 32); // JB - Remove this console.warn
            if ((Math.abs(npc.x - x) / 32 < 2) && (Math.abs(npc.y - y) / 32 < 2)) {
                npc.setAlpha(.33);
                npcText.visible = true;
            } else {
                npc.clearAlpha();
                npcText.visible = false;
            }
        });
        // END ADD NPC

        this.text = this.add.text(16, 16, '', {
            fontSize: '20px',
            fill: '#ffffff'
        });
        this.text.setScrollFactor(0);
    }

    hitCoin(sprite, tile) {
        this.coinLayer.removeTileAt(tile.x, tile.y);
        this.coinsCollected += 1;

        // Return true to exit processing collision of this tile vs the sprite - in this case, it
        // doesn't matter since the coin tiles are not set to collide.
        return false;
    }

    hitSecretDoor(sprite, tile) {
        tile.alpha = 0.25;

        // Return true to exit processing collision of this tile vs the sprite - here, we want to allow
        // the player jump "through" the block and not collide.
        return true;
    }

    update(time, delta) {
        // Horizontal movement
        (this.player.body as any).setVelocityX(0);
        if (this.cursors.left.isDown) {
            (this.player.body as any).setVelocityX(-200);
        }
        else if (this.cursors.right.isDown) {
            (this.player.body as any).setVelocityX(200);
        }
        if (this.frameCount % 4 === 0) {
            this.updateText();
            // Check if we are back on the ground to reset the second jump
            if (!this.doubleJump && this.player.body.onFloor()) {
                this.doubleJump = true;
            }
        }
        if (this.frameCount % 8 === 0) {
            // Dont want to update them too fast!
            this.updateCoins();
        }
        if (this.frameCount > 64000) {
            this.frameCount = 0;
        }
        this.frameCount++;
    }
    attemptJump() {
        if (this.player.body.onFloor()) {
            this.doubleJump = true;
            this.player.body.setVelocityY(-400);
        } else if (this.doubleJump) {
            this.doubleJump = false;
            this.player.body.setVelocityY(-400);
        }
    }

    drawDebug() {
        this.debugGraphics.clear();

        if (this.showDebug) {
            // Pass in null for any of the style options to disable drawing that component
            this.groundLayer.renderDebug(this.debugGraphics, {
                tileColor: null, // Non-colliding tiles
                collidingTileColor: new Phaser.Display.Color(243, 134, 48, 200), // Colliding tiles
                faceColor: new Phaser.Display.Color(40, 39, 37, 255) // Colliding face edges
            });
        }
    }

    updateText() {
        var location = this.player.getBottomLeft().lerp(this.player.getTopRight(), 0.5);
        this.text.setText(
            'Arrow keys to move. Space to jump' +
            '\nPress "C" to toggle debug visuals: ' + (this.showDebug ? 'on' : 'off') +
            '\nCoins collected: ' + this.coinsCollected +
            "\nLocation: (" + (location.x / 32).toFixed(0) + ", " + (location.y / 32).toFixed(0) + ")"
        );
    }

    updateCoins() {
        this.spriteTiles.forEach(x => {
            x.index++;
            if (x.index > 31) {
                x.index = 26;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/demos/phaserPlatformerDemo/scenes/MainScene.ts